import { render, staticRenderFns } from "./bulk-message-recipients-import-upload.vue?vue&type=template&id=34b1c61e&scoped=true&"
import script from "./bulk-message-recipients-import-upload.vue?vue&type=script&lang=js&"
export * from "./bulk-message-recipients-import-upload.vue?vue&type=script&lang=js&"
import style0 from "./bulk-message-recipients-import-upload.vue?vue&type=style&index=0&id=34b1c61e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b1c61e",
  null
  
)

export default component.exports